import { render, staticRenderFns } from "./ButtonOutlineSmall.vue?vue&type=template&id=f5bc2e84&"
import script from "./ButtonOutlineSmall.vue?vue&type=script&lang=js&"
export * from "./ButtonOutlineSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports